import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
/*import ProductList from "./Components/ProductList";
import ProductDetail from "./Components/ProductDetail";
import ProductFilter from "./Components/ProductFilter";
import FormPost from "./Components/FormPost";
import Contact from "./Components/Contact";*/

import FormClient from "./Components/FormClient";
import React from "react";

import Home from "./Components/Home";
import NotFound from "./Components/NotFound";
import Login from "./Components/Login";
import Profile from "./Components/Profile";
import Clients from "./Components/Clients";
//
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useStore } from "./store/generalStore";
import Documentation from "./Components/Documentation";
import Landing from "./Components/Landing";
import Servicios from "./Components/Servicios";

function App() {
	const { isLogued } = useStore();
	return (
		<div>
			<BrowserRouter>			
				<Routes>
					{isLogued ? (
						<>
							<Route path="/" element={<Home />} />
							<Route path="/login" element={<Login />} />
							<Route path="/home" element={<Home />} />
							<Route path="/profile" element={<Profile />} />
							<Route path="/clientes" element={<Clients />} />
							<Route path="/new-client" element={<FormClient />} />
							<Route path="/documentacion" element={<Documentation />} />
							<Route path="*" element={<NotFound />} />

						</>
					) : (
						<>
	
							<Route path="/login" element={<Login />} />
							<Route path="/" element={<Landing />} />
							<Route path="/servicios" element={<Servicios />} />
							<Route path="*" element={<NotFound />} />
							
						</>
					)}
				</Routes>
			</BrowserRouter>
			<ToastContainer />
		</div>
	);
}

export default App;
/* DE OTROS PROYECTOS
					<Route path="/producDetail" element={<ProductDetail />} />
					<Route path="/new-post" element={<FormPost />} />

					<Route path="/contacto" element={<Contact />} />
*/

/*


<ProductDetail />
<ProductFilter />
<Logos />
<FAQ />
<FormExample />
<Modal />

<div className="p-6">
      {showToast && (
        <Toast
          message="Successfully saved!"
          subMessage="Anyone with a link can now view this file."
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
*/
